import { createTheme } from "@mui/material/styles";
import { styled, alpha } from "@mui/material";
import { commonTransitions,commonTypography } from "./common";

const setLightTheme = (custom_palette) => {
  const { primary: palettePrimaryColor, secondary: paletteSecondaryColor } =
    custom_palette;

  const white = "#fff";

  const palette = {
    primary: {
      main: palettePrimaryColor,
      contrastText: white,
    },
    secondary: {
      main: paletteSecondaryColor,
    },
    background: {
      main: "#fff",
      secondary: "#f5f7fb",
    },
    text: {
      main: "#2b2b2b", // grey
      secondary: palettePrimaryColor, // primary.main
      tertiary: "#fff", // white
    },
  };

  const theme = createTheme({
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            border: `1px solid ${alpha(palettePrimaryColor, 0.1)}`,
          },
        },
      },
    },
    palette: palette,
    transitions:commonTransitions,
    typography: commonTypography,
  });

  return theme;
};

export default setLightTheme;
